import React from 'react'
import {selectTheme} from '../../store'
import {RIF} from '../../lib'
import {ProfileImageDefault} from '../../asset/image'

export const Avatars = (props) => {
  const {color} = selectTheme()

  // hard code now
  const overflowLimit = 3
  const {users, onClick, css: cssProp, ...rest} = props
  const displayUsers = users?.slice(0, overflowLimit)
  const overflowNumber = users?.length - 3

  const content = (
    <>
      {displayUsers
        .filter((u) => u.profile)
        .map((user, index) => {
          return (
            <img
              src={user.profile.imageUrl || ProfileImageDefault}
              width='28'
              height='28'
              key={index}
              alt={'Collaborator avatars'}
              css={{
                borderRadius: '50px',
                border: '1px solid white',
                marginLeft: '-8px',
              }}
            />
          )
        })}

      {RIF(
        !!overflowNumber && overflowNumber > 0,
        <div
          css={{
            height: '28px',
            width: '28px',
            borderRadius: '50px',
            background: color.white,
            border: `1px solid ${color.grey_700}`,
            color: color.grey_700,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '12px',
            fontWeight: '600',
            marginLeft: '-8px',
          }}>
          +{overflowNumber}
        </div>,
      )}
    </>
  )

  const containerCss = {
    height: '30px',
    position: 'relative',
    display: 'flex',
    paddingLeft: '8px',
    width: 'auto',
  }

  if (onClick) {
    return (
      <button
        type='button'
        onClick={onClick}
        {...rest}
        css={[
          containerCss,
          {
            border: 'none',
            background: 'transparent',
            cursor: 'pointer',
            font: 'inherit',
          },
          cssProp,
        ]}>
        {content}
      </button>
    )
  }

  return (
    <div {...rest} css={[containerCss, cssProp]}>
      {content}
    </div>
  )
}
